export default {
      id: "graph-cotenord-usage",
      viewBox: "0 0 175 175",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-cotenord",
      toString: function () {
        return this.url;
      }
    }